import {createCookie, readCookie} from 'extensions/cookies/cookies.js';
import MicroModal from 'micromodal';

// Set up variables for modal container, button acceptance and checking if the age verification cookie is present
var ageVerify = readCookie('mlv_age_verify');
var ageButton = document.querySelector('#ageVerifyContainer #modal-1-content button');

// Function that will be used to create the cookie and close the modal once the user acknowledges age verification
var ageSetActions = function () {
	// Create the cookie
	createCookie('mlv_age_verify', '1', 365);
	// Close it
	MicroModal.close('ageVerifyContainer');
};

// Fires once the user clicks the age verification
ageButton.onclick = function () {
	ageSetActions();
};

// Check if the mlv_age_verify cookie is set and display modal and remove the hidden class
if (ageVerify !== '1') {
	MicroModal.show('ageVerifyContainer', {
		closeTrigger: 'data-custom-close',
		disableFocus: true,
		disableScroll: true,
		onClose: function () { document.querySelector('body').classList.remove('c-micromodal__open'); },
		onShow: function () { document.querySelector('body').classList.add('c-micromodal__open'); }
	});
}

